import { Injectable } from '@angular/core';
import { IConstraint } from '../models/model.constraint';
import { ICheckedEntity } from '../models/abstractions';
import { SeConstraintCheckerService } from '../se-constraint-checker.service/se-constraint-checker.service';
import { SeConstraintConfiguratorService } from '../se-constraint-configurator.service/se-constraint-configurator.service';
import { ConstraintTypeEnum } from '../models/enum';
import { find } from 'lodash-es';
import { Utils } from '../../utils/utils';


@Injectable({
    providedIn: 'root',
})
export class SeConstraintApplierService {
    constructor(
        private constraintCheckerService: SeConstraintCheckerService,
        private constraintConfiguratorService: SeConstraintConfiguratorService,
    ) {}

    applyFilter(filterId: string): ICheckedEntity[] | null {
        let filter: IConstraint | undefined = find(
            this.constraintConfiguratorService.allConstraints,
            (c) => c.constraintType === ConstraintTypeEnum.Filter && c.id.toLowerCase() === filterId.toLowerCase(),
        );

        if (!filter) return [];

        const results = this.constraintCheckerService.checkConstraint(filter, true);
        const result = results[0]; //per i filtri il constraint non è mai multiplo
        return Array.isArray(result.matchingResult)
            ? result.matchingResult
            : result.partialResults
                  ?.filter((res) => res.matchingResult)
                  .map((i) => i.checkedEntity)
                  .filter(Utils.isNotEmpty) ?? null;
    }

    apply(id: string) {
        const constraints: IConstraint[] = this.constraintConfiguratorService.allConstraints.filter((c) => c.id === id);
        constraints.forEach((c) => this.constraintCheckerService.checkConstraint(c));
    }

    applyMany(ids: string[]) {
        if (!ids) return;

        ids.forEach((id) => this.apply(id));
    }

    applyNormalValues () {
        const normalValueConstraints: IConstraint[] = this.constraintConfiguratorService.allConstraints.filter(
            (c) => c.constraintType === ConstraintTypeEnum.NormalValue,
        );
        console.log('tutte le constraints che arrivano da constraintConfiguratorService', { allConstraints: this.constraintConfiguratorService.allConstraints });
        console.log('tutte le constraints relative ai valori normali', { normalValueConstraints: normalValueConstraints });
        normalValueConstraints.forEach((c) => this.constraintCheckerService.checkConstraint(c));
    }

    applyCalculations() {
        const calculationConstraints: IConstraint[] = this.constraintConfiguratorService.allConstraints.filter(
            (c) => c.constraintType === ConstraintTypeEnum.Calculation,
        );
        calculationConstraints.forEach((c) => this.constraintCheckerService.checkConstraint(c));
    }
}
